module.exports = __webpack_public_path__ + "static/img/full.645d31e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/cursor/full.png
// module id = dz2R
// module chunks = 0